var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { attrs: { fluid: "" } },
    [
      _c(
        "v-row",
        { staticClass: "d-flex flex-row" },
        [
          _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _c("FormPage", {
                attrs: {
                  data: _vm.page,
                  loading: _vm.isFormLoading,
                  disabled: _vm.isMutationLoading,
                  isNew: !_vm.id,
                  language: _vm.language,
                },
                on: {
                  "delete-page": _vm.deletePage,
                  "language-update": function ($event) {
                    _vm.language = $event
                  },
                  submit: _vm.formPageSubmit,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("ConfirmationDialog", {
        ref: "confirmEventRemoving",
        attrs: { confirmText: "Удалить" },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }